
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/auth/partnerships/apex-clearing",
      function () {
        return require("private-next-pages/docs/auth/partnerships/apex-clearing.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/auth/partnerships/apex-clearing"])
      });
    }
  